import { WorkingDaysTimeRangeDTO } from './WorkingDaysTimeRangeDTO';
import { DayOfWeek } from '@enum/common/DayOfWeek';
import { Type } from 'class-transformer';

export class WorkingDaysTimetableDTO {
  public dayOfWeek: DayOfWeek;

  @Type(() => WorkingDaysTimeRangeDTO)
  public hours: WorkingDaysTimeRangeDTO[] = [];
}